import "./chart_labels.scss";
import classNames from "classnames";
import { Text } from "@/elements/text/text";
import { type ReactElement } from "react";

// The label style uppercases via CSS, and Unicode uppercasing maps "ß" to "SS"
// ("Großbritannien" would read "GROSSBRITANNIEN"). Pre-swapping in the capital
// "ẞ" (U+1E9E) keeps the spelling intact, since CSS leaves it untouched.
function preserveEszett(value: string): string {
  return value.replace(/ß/g, "ẞ");
}

interface Props {
  labels: Array<{
    text: string;
    value: string;
    color: string;
  }>;
  layout?: "regions" | "countries";
}

export function ChartLabels({
  labels,
  layout = "regions",
}: Props): ReactElement {
  return (
    <ul
      className={classNames("chart-labels", {
        "chart-labels--countries": layout === "countries",
      })}
    >
      {labels.map((item) => {
        return (
          <li key={item.text} className="chart-labels__item">
            <span
              className="chart-labels__dot"
              style={
                {
                  "--label-color": `${item.color}`,
                } as React.CSSProperties
              }
            />
            <span className="chart-labels__text">
              <Text
                type="micro"
                color="neutral-on-surface-lightest"
                htmlElement="span"
              >
                {preserveEszett(item.text)}
              </Text>
            </span>
            <span className="chart-labels__value">
              <Text
                type="snippet"
                color="inverted-pairings-default"
                htmlElement="span"
              >
                {item.value}
              </Text>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
